import { z } from 'zod';
const id = z.string().trim().min(1).max(240);
const text = z.string().trim().min(1).max(8000);
export const AufgabenQuelleSchema = z.object({ id, referenz: text, zitat: text }).strict();
export const AufgabenZustandSchema = z.enum(['erfasst','geplant','in_arbeit','blockiert','erledigt','zurueckgestellt']);
export const AufgabenMetadatenSchema = z.object({
  version: z.number().int().positive(), buehneId: id, quellen: z.array(AufgabenQuelleSchema).min(1).max(100),
  fertigWenn: text, naechsterSchritt: text, zustaendig: text,
  zustand: AufgabenZustandSchema, grund: z.string().max(8000).optional(),
  ergebnis: z.object({ referenz: text, befund: text, am: z.string(), von: id }).optional(),
  freigegebenesZiel: z.object({milestoneId:id,von:id,am:z.string(),herkunft:z.enum(['mensch','bestand'])}).optional(),
  zuordnung: z.object({ status: z.enum(['vorschlag','bestaetigt','zurueckgestellt']), milestoneId: id, begruendung: text,
    von: id, am: z.string(), antwortVon: id.optional(), antwortAm: z.string() }).partial({ antwortAm: true }),
  verlauf: z.array(z.object({ am: z.string(), von: id, art: text, text })),
}).strict();
export type AufgabenMetadaten = z.infer<typeof AufgabenMetadatenSchema>;
export const AufgabenVorschlagSchema = z.object({
  stepId: id.optional(), basisVersion: z.number().int().nonnegative().optional(),
  text: z.string().trim().min(1).max(72), detail: z.string().max(16000).optional(),
  milestoneId: id, quelle: AufgabenQuelleSchema, fertigWenn: text, naechsterSchritt: text, zustaendig: text, begruendung: text,
}).strict();
export const AufgabenAntwortSchema = z.object({ basisVersion: z.number().int().positive(),
  entscheidung: z.enum(['uebernehmen','anders','zurueckstellen']), milestoneId: id.optional(), grund: z.string().trim().max(8000).optional(),
}).strict();
export const AufgabenFortschrittSchema = z.object({ basisVersion: z.number().int().positive(),
  zustand: AufgabenZustandSchema, naechsterSchritt: text, grund: z.string().trim().max(8000).optional(),
  ergebnis: z.object({ referenz: text, befund: text }).optional(),
}).strict();
export const AufgabenAbgleichSchema = z.object({ quellenFassung: id, aufgaben: z.array(id).max(1000),
  versionen:z.record(z.number().int().positive()), begruendung: text, luecken: z.array(text).max(100),
  bestandsAusnahmen:z.array(z.object({stepId:id,fassung:z.string().regex(/^[a-f0-9]{64}$/),grund:text,referenz:text}).strict()).max(1000).optional(), }).strict();
export const AufgabenAbgleichGespeichertSchema = AufgabenAbgleichSchema.extend({ am:z.string(),von:id,versionen:z.record(z.number().int().positive()) });
export type AufgabenAbgleich = z.infer<typeof AufgabenAbgleichGespeichertSchema>;
export const AufgabenAnsichtSchema = z.object({
  buehneId: id, aktiveBuehneId:id, quellenFassung: id, abgleich: AufgabenAbgleichGespeichertSchema.nullable(),
  ziele: z.array(z.object({ id, titel:z.string(), thema:z.string() })),
  aufgaben: z.array(z.object({ id, text:z.string(), detail:z.string().optional(), done:z.boolean(),
    milestoneId:id, ziel:z.string(), thema:z.string(), aufgabe:AufgabenMetadatenSchema,
    einplanung:z.array(z.object({ id, scope:z.string().optional(), date:z.string().optional(), carriedFrom:z.string().optional(), carryCount:z.number().optional() })),
  })),
  bestehendeSchritte:z.array(z.object({ id, text:z.string(), done:z.boolean(), fassung:z.string().optional() })),
  arbeitGemessen:z.boolean().nullable(), hinweise:z.array(z.string()),
});
export type AufgabenAnsicht = z.infer<typeof AufgabenAnsichtSchema>;
